(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[266],{

/***/ "9xag":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/widgets/tour-information/TourInformation.jsx
var TourInformation = __webpack_require__("HnVD");

// CONCATENATED MODULE: ./src/client/components/lines/tour-practical-information-line/TourPracticalInformationLine.jsx
var __jsx = react_default.a.createElement;



var TourPracticalInformationLine_TourPracticalInformationLine = function TourPracticalInformationLine(props) {
  if (!props.resort) {
    return null;
  }

  var _props$resort$practic = props.resort.practicalInformation,
      includedInPackage = _props$resort$practic.includedInPackage,
      excludedInPackage = _props$resort$practic.excludedInPackage,
      healthFormalities = _props$resort$practic.healthFormalities,
      passportAndVisas = _props$resort$practic.passportAndVisas,
      immigrationFormalities = props.immigrationFormalities,
      healthFormalitiesTitle = props.healthFormalities,
      includedInTour = props.includedInTour,
      notIncludedInTour = props.notIncludedInTour;
  var infos = [];

  if (includedInPackage && includedInPackage.length) {
    infos.push({
      title: includedInTour,
      items: includedInPackage
    });
  }

  if (excludedInPackage && excludedInPackage.length) {
    infos.push({
      title: notIncludedInTour,
      items: excludedInPackage
    });
  }

  if (passportAndVisas) {
    infos.push({
      title: immigrationFormalities,
      text: passportAndVisas
    });
  }

  if (healthFormalities) {
    infos.push({
      title: healthFormalitiesTitle,
      text: healthFormalities
    });
  }

  if (!infos.length) {
    return null;
  }

  return __jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, __jsx(TourInformation["a" /* TourInformation */], {
    infos: infos
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/tour-practical-information/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (TourPracticalInformationLine_TourPracticalInformationLine);

/***/ })

}]);